import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  subTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    color: '#2C2D3E',
    padding: '0px 5px 0px 25px',
  },
  item: {
    display: 'flex',
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'space-between',
    maxHeight: '70px',
    padding: '10px 25px 10px 20px',
    '& .MuiFormHelperText-contained': {
      margin: '0',
    },
  },
  helperRow: {
    height: '20px',
  },
  errorMessage: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    color: '#BC0000',
  },
  errorBanner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '28px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 200,
    fontSize: '12px',
    color: '#BC0000',
    background: 'rgba(188, 0, 0, 0.05)',
    borderRadius: '5px',
    margin: '5px 10px 5px 15px',
  },
  fieldLimits: {
    textAlign: 'right',
    color: '#2C2D3E',
  },
  line: {
    position: 'relative',
    width: '100%',
    size: '0px',
    color: '#2c2d3e',
    opacity: 0.3,
    display: 'inline-block',
    align: 'center',
    maxHeight: '20px',
  },
  addButton: {
    width: '90px',
    zIndex: 1,
    cursor: 'pointer',
    color: '#fff',
    backgroundColor: '#347F42',
    '&:hover': {
      background: '#266733',
    },
  },
  deleteButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '20px',
    fontFamily: 'Roboto',
    fontSize: '13px',
    color: '#BC0000',
    paddingRight: '10px',
    cursor: 'pointer',
  },
}));
